module.exports = __webpack_public_path__ + "static/test_bg.61b495ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/test_bg.jpg
// module id = 3220
// module chunks = 208176855801404